import request from '@/utils/request';

export interface AnnouncementVO {
  id: number;
  title: string;
  content: string;
  type: number;
  priority: number;
  publisherId: number;
  publishTime: string;
  sortOrder: number;
  isRead: number; // 0-未读，1-已读
  readTime?: string;
  createTime: string;
}

export interface PageResult<T> {
  records: T[];
  total: number;
  current: number;
  size: number;
}

// 实际的API响应格式（经过响应拦截器处理后）
export interface AnnouncementListResponse {
  records: AnnouncementVO[];
  total: number;
  current: number;
  size: number;
}

export interface TopAnnouncement {
  id: number;
  title: string;
  content: string;
  type: number;
  priority: number;
  targetUserIds: string;
  publisherId: number;
  publishTime: string;
  status: number;
  sortOrder: number;
  createTime: string;
  updateTime: string;
}

export const userAnnouncementApi = {
  // 获取公告列表
  getAnnouncementList(page = 1, pageSize = 10) {
    console.log(`[Announcement API] Fetching announcement list - page: ${page}, pageSize: ${pageSize}`);
    return request<AnnouncementListResponse>({
      url: '/user/announcement/list',
      method: 'get',
      params: { page, pageSize }
    }).then(response => {
      console.log('[Announcement API] Response received:', response);
      return response;
    }).catch(error => {
      console.error('[Announcement API] Error fetching announcement list:', error);
      throw error;
    });
  },

  // 根据您提供的API文档，添加获取前5条系统公告的函数
  getTopFiveAnnouncements() {
    console.log('[Announcement API] Fetching top 5 announcements');
    return request<TopAnnouncement[]>({
      url: '/user/dashboard/announcements/top5',
      method: 'get'
    }).then(response => {
      console.log('[Announcement API] Top 5 announcements response:', response);
      return response;
    }).catch(error => {
      console.error('[Announcement API] Error fetching top 5 announcements:', error);
      throw error;
    });
  },

  // 标记公告为已读
  markAnnouncementAsRead(announcementId: number) {
    console.log(`[Announcement API] Marking announcement as read - id: ${announcementId}`);
    return request({
      url: `/user/announcement/read/${announcementId}`,
      method: 'put'
    }).then(response => {
      console.log('[Announcement API] Mark as read response:', response);
      return response;
    }).catch(error => {
      console.error('[Announcement API] Error marking announcement as read:', error);
      throw error;
    });
  },

  // 批量标记已读
  batchMarkAsRead(announcementIds: number[]) {
    console.log(`[Announcement API] Batch marking as read - ids:`, announcementIds);
    return request({
      url: '/user/announcement/read-all',
      method: 'put',
      data: announcementIds
    }).then(response => {
      console.log('[Announcement API] Batch mark as read response:', response);
      return response;
    }).catch(error => {
      console.error('[Announcement API] Error in batch mark as read:', error);
      throw error;
    });
  },

  // 获取未读公告数
  getUnreadCount() {
    console.log('[Announcement API] Fetching unread count');
    return request<number>({
      url: '/user/announcement/unread-count',
      method: 'get'
    }).then(response => {
      console.log('[Announcement API] Unread count response:', response);
      return response;
    }).catch(error => {
      console.error('[Announcement API] Error fetching unread count:', error);
      throw error;
    });
  }
};